<template>
  <section>
    <form @submit.prevent="submit">
      <div v-if="disable">
        <div class="columns no-margin-bottom">
          <div class="column">
            <b-field label="Report ID">
              <b-input
                name="customer_name"
                :disabled="true"
                v-model="form.r_id"
              >
              </b-input>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Country">
              <b-select
                class="enable-select-text"
                name="country"
                :disabled="disable"
                v-model="form.country_id"
                v-on:input="filterScheme"
                required
                expanded
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in countries"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div class="columns no-margin-bottom">
          <div class="column">
            <b-field label="Customer Name">
              <template #label>
                Customer Name
                <b-tooltip
                  type="is-primary is-cursor"
                  label="You will be redirected to Customer Profile"
                  v-if="!isExternalUser"
                >
                  <span @click.prevent="redirectToCustomerProfile">
                    <b-icon size="is-small" icon="open-in-new"></b-icon>
                  </span>
                </b-tooltip>
              </template>
              <!-- <b-input  name="customer_name" v-model="form.customer_id" :disabled="disable" required/> -->
              <b-select
                v-if="form.parent_customer_id"
                class="enable-select-text"
                name="parent_customer_id"
                :disabled="disable"
                expanded
                v-model="form.parent_customer_id"
                required
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in customers"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.name }}
                </option>
              </b-select>
              <b-select
                v-else
                class="enable-select-text"
                name="customer_name"
                :disabled="disable"
                expanded
                v-model="form.customer_id"
                v-on:input="setAccountManager"
                required
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in customers"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Scheme">
              <b-select
                class="enable-select-text"
                name="scheme"
                placeholder="Please select"
                :disabled="disable"
                v-model="form.scheme_id"
                v-on:input="filterStream"
                required
                expanded
              >
                <option
                  v-for="option in schemes"
                  :value="option.id"
                  :key="option.id"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div class="columns no-margin-bottom">
          <div class="column">
            <b-field label="Customer Local Entity">
              <!-- <b-input  name="customer_name" v-model="form.customer_id" :disabled="disable" required/> -->
              <b-select
                v-if="form.parent_customer_id"
                class="enable-select-text"
                name="customer_id"
                :disabled="disable"
                expanded
                v-model="form.customer_id"
                v-on:input="setAccountManager"
                required
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in customers"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.name }}
                </option>
              </b-select>
              <b-select
                v-else
                class="enable-select-text"
                name="parent_customer_id"
                :disabled="disable"
                expanded
                v-model="form.parent_customer_id"
                required
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in customers"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Stream">
              <b-select
                class="enable-select-text"
                name="stream"
                :disabled="disable"
                v-model="form.stream_id"
                v-on:input="filterReports"
                required
                expanded
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in containers"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div class="columns no-margin-bottom">
          <div class="column">
            <b-field label="Customer Account Manager">
              <b-select
                class="enable-select-text"
                name="customer_account_manager"
                :disabled="true"
                expanded
                v-model="form.customer_account_manager_id"
                required
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in users"
                  :value="option.id"
                  :key="index"
                  :disabled="option.is_active == false"
                  :hidden="option.is_active == false"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Report Type">
              <template #label>
                Report Type
                <b-tooltip
                  type="is-primary is-cursor"
                  label="You will be redirected to Report Type in KDB"
                  v-if="!isExternalUser"
                >
                  <span @click.prevent="redirectToKDB">
                    <b-icon size="is-small" icon="open-in-new"></b-icon>
                  </span>
                </b-tooltip>
              </template>
              <b-select
                class="enable-select-text"
                name="report_type"
                :disabled="disable"
                v-model="form.report_id"
                required
                expanded
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in reports"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.report_type }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div class="columns no-margin-bottom">
          <div class="column">
            <b-field label="Reporting Responsible" v-if="!isExternalUser">
              <b-select
                class="enable-select-text"
                name="reporting_responsible"
                :disabled="disableReportingResponsible"
                expanded
                v-model="form.reporting_responsible"
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in rrUsers"
                  :value="option.id"
                  :key="index"
                  :disabled="option.is_active == false"
                  :hidden="option.is_active == false"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
            <b-field label="Period" v-else>
              <template #label>
                Period
                <b-tooltip
                  v-if="!disable"
                  type="is-primary"
                  label="Please provide the period this One-Off report relates to"
                >
                  <b-icon size="is-small" icon="help-circle-outline"></b-icon>
                </b-tooltip>
              </template>
              <b-input
                name="period"
                :disabled="disable"
                expanded
                v-model="form.period"
                required
              />
            </b-field>
          </div>
          <div class="column">
            <b-field label="Scheme Deadline">
              <template #label>
                Scheme Deadline
                <b-tooltip
                  v-if="!disable"
                  type="is-primary"
                  label="Please provide the scheme deadline for this One-Off Report"
                >
                  <b-icon size="is-small" icon="help-circle-outline"></b-icon>
                </b-tooltip>
              </template>
              <b-datepicker
                name="planned_scheme_deadline"
                :disabled="disable"
                v-model="form.planned_scheme_deadline"
                :date-formatter="dateFormatter"
                icon="calendar-today"
                :date-parser="dateParser"
                trap-focus
                editable
                required
              >
                <b-button
                  type="is-danger"
                  @click="form.planned_scheme_deadline = null"
                >
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </b-button>
              </b-datepicker>
            </b-field>
          </div>
        </div>
        <div class="columns no-margin-bottom">
          <div class="column">
            <b-field label="Period" v-if="!isExternalUser">
              <template #label>
                Period
                <b-tooltip
                  v-if="!disable"
                  type="is-primary"
                  label="Please provide the period this One-Off report relates to"
                >
                  <b-icon size="is-small" icon="help-circle-outline"></b-icon>
                </b-tooltip>
              </template>
              <b-input
                name="period"
                :disabled="disable"
                expanded
                v-model="form.period"
                required
              />
            </b-field>
            <b-field label="Date of delivering final dataset" v-else>
              <b-datepicker
                name="final_dataset_delivery_date"
                :disabled="disableView || isExternalUser"
                actual_submission_date
                v-model="form.final_dataset_delivery_date"
                placeholder="Not Applicable"
                :date-formatter="dateFormatter"
                icon="calendar-today"
                :date-parser="dateParser"
                trap-focus
              >
                <b-button
                  type="is-danger"
                  @click="form.final_dataset_delivery_date = null"
                >
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </b-button>
              </b-datepicker>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Revised Scheme Deadline">
              <b-datepicker
                name="revised_scheme_deadline"
                :disabled="disableView || isExternalUser"
                v-model="form.revised_scheme_deadline"
                :date-formatter="dateFormatter"
                icon="calendar-today"
                :date-parser="dateParser"
                trap-focus
              >
                <b-button
                  type="is-danger"
                  @click="form.revised_scheme_deadline = null"
                >
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </b-button>
              </b-datepicker>
            </b-field>
          </div>
        </div>
        <div class="columns no-margin-bottom">
          <div class="column">
            <b-field
              label="Date of delivering final dataset"
              v-if="!isExternalUser"
            >
              <b-datepicker
                name="final_dataset_delivery_date"
                :disabled="disableView || isExternalUser"
                actual_submission_date
                v-model="form.final_dataset_delivery_date"
                placeholder="Not Applicable"
                :date-formatter="dateFormatter"
                icon="calendar-today"
                :date-parser="dateParser"
                trap-focus
              >
                <b-button
                  type="is-danger"
                  @click="form.final_dataset_delivery_date = null"
                >
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </b-button>
              </b-datepicker>
            </b-field>
            <b-field label="Actual submission date" v-else>
              <b-datepicker
                name="actual_submission_date"
                :disabled="disableView || isExternalUser"
                v-model="form.actual_submission_date"
                :date-formatter="dateFormatter"
                icon="calendar-today"
                :date-parser="dateParser"
                trap-focus
              >
                <b-button
                  type="is-danger"
                  @click="form.actual_submission_date = null"
                >
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </b-button>
              </b-datepicker>
            </b-field>
            <b-field label="Actual submission date" v-if="!isExternalUser">
              <b-datepicker
                name="actual_submission_date"
                :disabled="disableView"
                v-model="form.actual_submission_date"
                :date-formatter="dateFormatter"
                icon="calendar-today"
                :date-parser="dateParser"
                trap-focus
              >
                <b-button
                  type="is-danger"
                  @click="form.actual_submission_date = null"
                >
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </b-button>
              </b-datepicker>
            </b-field>
            <b-field label="Proof of submission">
              <b-upload
                v-model="file"
                class="file-label"
                :disabled="disableView || isExternalUser"
                multiple
                drag-drop
                v-if="!disableView"
                ><span>
                  <section class="section">
                    <div class="content has-text-centered">
                      <p>
                        <b-icon icon="upload" size="is-large"> </b-icon>
                      </p>
                      <p>Drop your files here or click to upload</p>
                    </div>
                  </section></span
                >
              </b-upload>
            </b-field>
            <div class="tags">
              <span
                v-for="(file, index) in file"
                :key="index"
                class="tag is-primary download-document"
              >
                <span @click.prevent="downloadProof(file)">
                  {{ file.name }}
                </span>
                <button
                  v-if="!disableView && !isExternalUser"
                  class="delete is-small"
                  type="button"
                  @click="deleteFromFile(index)"
                ></button>
              </span>

              <div v-if="pos_document.length > 0">
                <span
                  v-for="(file, index) in pos_document"
                  :key="index"
                  class="tag is-primary download-document"
                >
                  <span @click.prevent="downloadProof(file)">
                    {{ file.proof_of_submission }}
                  </span>
                  <button
                    v-if="!disableView && !isExternalUser"
                    class="delete is-small"
                    type="button"
                    @click="deleteFromPosDocument(index)"
                  ></button>
                </span>
              </div>
            </div>
            <span v-if="pos_document.length == 0 || file.length > 0">
              <p v-if="!disableView && !isExternalUser">
                Click “save” to upload PoS
              </p>
              <p v-else>NA</p>
            </span>
          </div>
          <div class="column">
            <b-field label="Comment" v-if="!isExternalUser">
              <b-input
                type="textarea"
                name="comments"
                :disabled="isExternalUser ? true : disableView"
                v-model="form.comments"
                class="reporting-tracker-textarea"
              ></b-input>
            </b-field>
            <b-field :label="isExternalUser ? 'Comment' : 'External Comment'">
              <b-input
                type="textarea"
                name="comments_external"
                :disabled="disableView || isExternalUser"
                v-model="form.comments_external"
                class="reporting-tracker-textarea"
              ></b-input>
            </b-field>
            <b-field label="Landbell Entity" v-if="!isExternalUser">
              <b-select
                name="landbell_entity"
                :disabled="true"
                v-model="form.landbell_entity"
                expanded
                placeholder="Please select"
              >
                <option
                  selected
                  v-for="(option, index) in landbellEntities"
                  :value="option"
                  :key="index"
                >
                  {{ option }}
                </option>
              </b-select>
            </b-field>
            <div class="columns no-margin-top" v-if="isExternalUser">
              <div class="column">
                <b-field label="Data Upload">
                  <b-upload
                    v-model="dataUpload"
                    class="file-label data-upload"
                    :disabled="disableView"
                    multiple
                    drag-drop
                    v-if="!disableView"
                    @input="uploadData"
                    ><span>
                      <section class="section">
                        <div class="content has-text-centered">
                          <p>
                            <b-icon icon="upload" size="is-large"> </b-icon>
                          </p>
                          <p>Drop your files here or click to upload</p>
                        </div>
                      </section></span
                    >
                  </b-upload>
                </b-field>
                <div class="tags">
                  <span
                    v-for="(file, index) in dataUpload"
                    :key="index"
                    class="tag is-primary download-document"
                  >
                    <span @click.prevent="downloadDataUpload(file)">
                      {{ file.name }}
                    </span>
                    <button
                      v-if="!disableView"
                      class="delete is-small"
                      type="button"
                      @click="deleteFromdataUpload(index)"
                    ></button>
                  </span>

                  <div v-if="data_document.length > 0">
                    <span
                      v-for="(file, index) in data_document"
                      :key="index"
                      class="tag is-primary download-document"
                    >
                      <span @click.prevent="downloadDataUpload(file)">
                        {{ file.document }}
                      </span>
                      <button
                        v-if="!disableView"
                        class="delete is-small"
                        type="button"
                        @click="deleteFromdataDocument(index)"
                      ></button>
                    </span>
                  </div>
                </div>
                <span v-if="data_document.length == 0 || dataUpload.length > 0">
                  <p v-if="!disableView"></p>
                  <p v-else>NA</p>
                </span>
              </div>
              <div class="column">
                <b-field label="Data Upload Comment">
                  <b-input
                    type="textarea"
                    name="comment"
                    :disabled="disableView"
                    v-model="form.data_upload_comment"
                  />
                </b-field>
              </div>
            </div>
            <!-- <b-field label="Resubmitted" v-else>
              <b-select
                name="resubmitted"
                :disabled="disableView || isExternalUser"
                v-model="form.resubmitted"
                expanded
                placeholder="Please select"
              >
                <option
                  selected
                  v-for="(option, index) in resubmitted"
                  :value="option"
                  :key="index"
                >
                  {{ option }}
                </option>
              </b-select>
            </b-field> -->
          </div>
        </div>
        <div class="columns no-margin-bottom">
          <div class="column">
            <b-field label="Status">
              <b-select
                name="status"
                :disabled="disableView || isExternalUser"
                v-model="form.status"
                expanded
                placeholder="Please select"
              >
                <option
                  selected
                  v-for="(option, index) in status"
                  :value="option"
                  :key="index"
                >
                  {{ option }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Resubmitted" v-if="!isExternalUser">
              <b-select
                name="resubmitted"
                :disabled="disableView"
                v-model="form.resubmitted"
                expanded
                placeholder="Please select"
              >
                <option
                  selected
                  v-for="(option, index) in resubmitted"
                  :value="option"
                  :key="index"
                >
                  {{ option }}
                </option>
              </b-select>
            </b-field>
            <!-- <b-field label="Date of resubmission" v-else>
              <b-datepicker
                name="date_of_resubmission"
                :disabled="disableView || isExternalUser"
                v-model="form.date_of_resubmission"
                :date-formatter="dateFormatter"
                icon="calendar-today"
                :date-parser="dateParser"
                trap-focus
              >
                <b-button
                  type="is-danger"
                  @click="form.date_of_resubmission = null"
                >
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </b-button>
              </b-datepicker>
            </b-field> -->
          </div>
        </div>
        <div class="columns no-margin-bottom" v-if="!isExternalUser">
          <div class="column columns no-margin-top">
            <div class="column">
              <b-field label="Data Upload">
                <b-upload
                  v-model="dataUpload"
                  class="file-label data-upload"
                  :disabled="disableView"
                  multiple
                  drag-drop
                  v-if="!disableView"
                  @input="uploadData"
                  ><span>
                    <section class="section">
                      <div class="content has-text-centered">
                        <p>
                          <b-icon icon="upload" size="is-large"> </b-icon>
                        </p>
                        <p>Drop your files here or click to upload</p>
                      </div>
                    </section></span
                  >
                </b-upload>
              </b-field>
              <div class="tags">
                <span
                  v-for="(file, index) in dataUpload"
                  :key="index"
                  class="tag is-primary download-document"
                >
                  <span @click.prevent="downloadDataUpload(file)">
                    {{ file.name }}
                  </span>
                  <button
                    v-if="!disableView"
                    class="delete is-small"
                    type="button"
                    @click="deleteFromdataUpload(index)"
                  ></button>
                </span>

                <div v-if="data_document.length > 0">
                  <span
                    v-for="(file, index) in data_document"
                    :key="index"
                    class="tag is-primary download-document"
                  >
                    <span @click.prevent="downloadDataUpload(file)">
                      {{ file.document }}
                    </span>
                    <button
                      v-if="!disableView"
                      class="delete is-small"
                      type="button"
                      @click="deleteFromdataDocument(index)"
                    ></button>
                  </span>
                </div>
              </div>
              <span v-if="data_document.length == 0 || dataUpload.length > 0">
                <p v-if="!disableView"></p>
                <p v-else>NA</p>
              </span>
            </div>
            <div class="column" style="padding-right:0px;">
              <b-field label="Data Upload Comment">
                <b-input
                  type="textarea"
                  name="comment"
                  :disabled="disableView"
                  v-model="form.data_upload_comment"
                />
              </b-field>
            </div>
          </div>
          <div class="column">
            <div class="column" style="padding-right:0px;">
              <b-field label="Date of resubmission" v-if="!isExternalUser">
                <b-datepicker
                  name="date_of_resubmission"
                  :disabled="disableView"
                  v-model="form.date_of_resubmission"
                  :date-formatter="dateFormatter"
                  icon="calendar-today"
                  :date-parser="dateParser"
                  trap-focus
                >
                  <b-button
                    type="is-danger"
                    @click="form.date_of_resubmission = null"
                  >
                    <b-icon icon="close"></b-icon>
                    <span>Clear</span>
                  </b-button>
                </b-datepicker>
              </b-field>
            </div>
          </div>
        </div>
        <!-- <div class="columns">
          <div class="column"></div>
          <div class="column">
            <div class="columns no-margin-bottom">
              <div class="column"></div>
            </div>
          </div>
        </div> -->
      </div>
      <div v-else>
        <div class="columns no-margin-bottom">
          <div class="column">
            <b-field label="Customer Name">
              <template #label>
                Customer Name
                <b-tooltip
                  type="is-primary is-cursor"
                  label="You will be redirected to Customer Profile"
                  v-if="!isExternalUser"
                >
                  <span @click.prevent="redirectToCustomerProfile">
                    <b-icon size="is-small" icon="open-in-new"></b-icon>
                  </span>
                </b-tooltip>
              </template>
              <!-- <b-input  name="customer_name" v-model="form.customer_id" :disabled="disable" required/> -->
              <b-select
                class="enable-select-text"
                name="customer_name"
                :disabled="disable"
                expanded
                v-model="form.customer_id"
                v-on:input="setAccountManager"
                required
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in customers"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Country">
              <b-select
                class="enable-select-text"
                name="country"
                :disabled="disable"
                v-model="form.country_id"
                v-on:input="filterScheme"
                required
                expanded
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in countries"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div class="columns no-margin-bottom">
          <div class="column">
            <b-field label="Customer Account Manager">
              <b-select
                class="enable-select-text"
                name="customer_account_manager"
                :disabled="true"
                expanded
                v-model="form.customer_account_manager_id"
                required
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in users"
                  :value="option.id"
                  :key="index"
                  :disabled="option.is_active == false"
                  :hidden="option.is_active == false"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Scheme">
              <b-select
                class="enable-select-text"
                name="scheme"
                placeholder="Please select"
                :disabled="disable"
                v-model="form.scheme_id"
                v-on:input="filterStream"
                required
                expanded
              >
                <option
                  v-for="option in schemes"
                  :value="option.id"
                  :key="option.id"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div class="columns no-margin-bottom">
          <div class="column">
            <b-field label="Reporting Responsible" v-if="!isExternalUser">
              <b-select
                class="enable-select-text"
                name="reporting_responsible"
                :disabled="disableReportingResponsible"
                expanded
                v-model="form.reporting_responsible"
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in rrUsers"
                  :value="option.id"
                  :key="index"
                  :disabled="option.is_active == false"
                  :hidden="option.is_active == false"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Stream">
              <b-select
                class="enable-select-text"
                name="stream"
                :disabled="disable"
                v-model="form.stream_id"
                v-on:input="filterReports"
                required
                expanded
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in containers"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div class="columns no-margin-bottom">
          <div class="column">
            <b-field label="Period">
              <template #label>
                Period
                <b-tooltip
                  v-if="!disable"
                  type="is-primary"
                  label="Please provide the period this One-Off report relates to"
                >
                  <b-icon size="is-small" icon="help-circle-outline"></b-icon>
                </b-tooltip>
              </template>
              <b-input
                name="period"
                :disabled="disable"
                expanded
                v-model="form.period"
                required
              />
            </b-field>
          </div>
          <div class="column">
            <b-field label="Report Type">
              <template #label>
                Report Type
                <b-tooltip
                  type="is-primary is-cursor"
                  label="You will be redirected to Report Type in KDB"
                  v-if="!isExternalUser"
                >
                  <span @click.prevent="redirectToKDB">
                    <b-icon size="is-small" icon="open-in-new"></b-icon>
                  </span>
                </b-tooltip>
              </template>
              <b-select
                class="enable-select-text"
                name="report_type"
                :disabled="disable"
                v-model="form.report_id"
                required
                expanded
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in reports"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.report_type }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div class="columns no-margin-bottom">
          <div class="column">
            <b-field label="Date of delivering final dataset">
              <b-datepicker
                name="final_dataset_delivery_date"
                :disabled="disableView || isExternalUser"
                actual_submission_date
                v-model="form.final_dataset_delivery_date"
                placeholder="Not Applicable"
                :date-formatter="dateFormatter"
                icon="calendar-today"
                :date-parser="dateParser"
                trap-focus
              >
                <b-button
                  type="is-danger"
                  @click="form.final_dataset_delivery_date = null"
                >
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </b-button>
              </b-datepicker>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Scheme Deadline">
              <template #label>
                Scheme Deadline
                <b-tooltip
                  v-if="!disable"
                  type="is-primary"
                  label="Please provide the scheme deadline for this One-Off Report"
                >
                  <b-icon size="is-small" icon="help-circle-outline"></b-icon>
                </b-tooltip>
              </template>
              <b-datepicker
                name="planned_scheme_deadline"
                :disabled="disable"
                v-model="form.planned_scheme_deadline"
                :date-formatter="dateFormatter"
                icon="calendar-today"
                :date-parser="dateParser"
                trap-focus
                editable
                required
              >
                <b-button
                  type="is-danger"
                  @click="form.planned_scheme_deadline = null"
                >
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </b-button>
              </b-datepicker>
            </b-field>
          </div>
        </div>
        <div class="columns no-margin-bottom">
          <div class="column">
            <b-field label="Actual submission date">
              <b-datepicker
                name="actual_submission_date"
                :disabled="disableView || isExternalUser"
                v-model="form.actual_submission_date"
                :date-formatter="dateFormatter"
                icon="calendar-today"
                :date-parser="dateParser"
                trap-focus
              >
                <b-button
                  type="is-danger"
                  @click="form.actual_submission_date = null"
                >
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </b-button>
              </b-datepicker>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Revised Scheme Deadline">
              <b-datepicker
                name="revised_scheme_deadline"
                :disabled="disableView || isExternalUser"
                v-model="form.revised_scheme_deadline"
                :date-formatter="dateFormatter"
                icon="calendar-today"
                :date-parser="dateParser"
                trap-focus
              >
                <b-button
                  type="is-danger"
                  @click="form.revised_scheme_deadline = null"
                >
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </b-button>
              </b-datepicker>
            </b-field>
          </div>
        </div>
        <div class="columns no-margin-bottom">
          <div class="column">
            <div label="Proof of submission">
              <b-field label="Proof of submission">
                <b-upload
                  v-model="file"
                  class="file-label"
                  :disabled="disableView || isExternalUser"
                  multiple
                  drag-drop
                >
                  <span v-if="!disableView">
                    <section class="section">
                      <div class="content has-text-centered">
                        <p>
                          <b-icon icon="upload" size="is-large"> </b-icon>
                        </p>
                        <p>Drops your files here or click to upload</p>
                      </div>
                    </section>
                  </span>
                </b-upload>
              </b-field>
              <div class="tags">
                <span
                  v-for="(file, index) in file"
                  :key="index"
                  class="tag is-primary"
                >
                  {{ file.name }}
                  <button
                    v-if="!disableView && !isExternalUser"
                    class="delete is-small"
                    type="button"
                    @click="deleteFromFile(index)"
                  ></button>
                </span>
              </div>
            </div>
          </div>
          <div class="column">
            <b-field label="Comment" v-if="!isExternalUser">
              <b-input
                type="textarea"
                name="comments"
                :disabled="disableView"
                v-model="form.comments"
                class="reporting-tracker-textarea"
              ></b-input>
            </b-field>
          </div>
        </div>
        <div class="columns no-margin-bottom">
          <div class="column">
            <b-field label="Status">
              <b-select
                name="status"
                :disabled="disableView || isExternalUser"
                v-model="form.status"
                expanded
                placeholder="Please select"
              >
                <option
                  selected
                  v-for="(option, index) in status"
                  :value="option"
                  :key="index"
                >
                  {{ option }}
                </option>
              </b-select>
            </b-field>
            <b-field label="Resubmitted" v-if="!isExternalUser">
              <b-select
                name="resubmitted"
                :disabled="disableView || isExternalUser"
                v-model="form.resubmitted"
                expanded
                placeholder="Please select"
              >
                <option
                  selected
                  v-for="(option, index) in resubmitted"
                  :value="option"
                  :key="index"
                >
                  {{ option }}
                </option>
              </b-select>
            </b-field>
            <div class="columns">
              <div class="column">
                <div label="Data Upload">
                  <b-field label="Data Upload">
                    <b-upload
                      v-model="dataUpload"
                      class="file-label data-upload"
                      :disabled="disableView"
                      multiple
                      drag-drop
                      v-if="!disableView"
                      @input="uploadData"
                      ><span>
                        <section class="section">
                          <div class="content has-text-centered">
                            <p>
                              <b-icon icon="upload" size="is-large"> </b-icon>
                            </p>
                            <p>Drop your files here or click to upload</p>
                          </div>
                        </section></span
                      >
                    </b-upload>
                  </b-field>
                  <div class="tags">
                    <span
                      v-for="(file, index) in dataUpload"
                      :key="index"
                      class="tag is-primary"
                    >
                      {{ file.name }}
                      <button
                        class="delete is-small"
                        type="button"
                        @click="deleteFromdataUpload(index)"
                      ></button>
                    </span>
                  </div>
                </div>
                <span v-if="data_document.length == 0 || dataUpload.length > 0">
                  <p v-if="!disableView"></p>
                  <p v-else>NA</p>
                </span>
              </div>
              <div class="column">
                <b-field label="Data Upload Comment">
                  <b-input
                    type="textarea"
                    name="comment"
                    :disabled="disableView"
                    v-model="form.data_upload_comment"
                  />
                </b-field>
              </div>
            </div>
          </div>
          <div class="column">
            <b-field label="External Comment" v-if="!isExternalUser">
              <b-input
                type="textarea"
                name="comments_external"
                :disabled="disableView || isExternalUser"
                v-model="form.comments_external"
                class="reporting-tracker-textarea"
              ></b-input>
            </b-field>
            <b-field label="Date of resubmission" v-if="!isExternalUser">
              <b-datepicker
                name="date_of_resubmission"
                :disabled="disableView || isExternalUser"
                v-model="form.date_of_resubmission"
                :date-formatter="dateFormatter"
                icon="calendar-today"
                :date-parser="dateParser"
                trap-focus
              >
                <b-button
                  type="is-danger"
                  @click="form.date_of_resubmission = null"
                >
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </b-button>
              </b-datepicker>
            </b-field>
            <b-field label="Landbell Entity" v-if="!isExternalUser">
              <b-select
                name="landbell_entity"
                :disabled="true"
                v-model="form.landbell_entity"
                expanded
                placeholder="Please select"
              >
                <option
                  selected
                  v-for="(option, index) in landbellEntities"
                  :value="option"
                  :key="index"
                >
                  {{ option }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
        <!-- <div class="columns">
          <div class="column">

          </div>
          <div class="column">

          </div>
        </div> -->
      </div>
      <hr />
      <div class="columns">
        <div class="column">
          <b-button
            v-if="!disableView"
            slot="right"
            native-type="submit"
            type="is-primary"
            class="view-report-button"
          >
            Save
          </b-button>
          <b-button class="is-normal" @click="routeToReportingTracker">
            <span>Back</span>
          </b-button>
        </div>
      </div>
    </form>
    <ReportingTrackerHistory
      :is-active="isHistoryModalActive"
      :data="historyData"
      @cancel="isHistoryModalActive = false"
    ></ReportingTrackerHistory>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import ReportingTrackerHistory from "./ReportingTrackerHistory.vue";
import CountryDataService from "../../services/CountryDataService";
import ContainerDataService from "../../services/ContainerDataService";
import SchemeDataService from "../../services/SchemeDataService";
import UserDataService from "../../services/UserDataService";
import ReportingTrackerDataService from "../../services/ReportingTrackerDataService";
import CustomerProfileDataService from "../../services/CustomerProfileDataService";
import CustomerUploadService from "../../services/CustomerUploadService";
import { Permission } from "../../services/Permissions";
import { AuthService } from "@/services/AuthService";
import { UserGroup } from "../../services/UserGroups";
import UserPermissionMixin from "@/mixins/UserPermissionMixin";
import UtilityMixin from "@/mixins/UtilityMixin";
import ScopeMixin from "@/mixins/scopeMixin";

let screenPixelSize;
let pixelRatio;
// @group Reporting Tracker
export default {
  name: "ReportingTrackerAdd",
  mixins: [UserPermissionMixin, UtilityMixin, ScopeMixin],
  props: {
    isAction: {
      type: String,
      default: null
    }
  },
  components: {
    ReportingTrackerHistory
  },
  data() {
    return {
      file_name: "",
      isModalActive: false,
      reportingResponsibleDisable: true,
      file: [],
      dataUpload: [],
      customer_name: null,
      authService: new AuthService(),
      reportingTrackerService: new ReportingTrackerDataService(),
      userDataService: new UserDataService(),
      customerDataService: new CustomerProfileDataService(),
      customerUploadService: new CustomerUploadService(),
      containerDataService: new ContainerDataService(),
      countryDataService: new CountryDataService(),
      schemeDataService: new SchemeDataService(),
      schemes: [],
      reports: [],
      reporting_types: ["B2B", "B2C"],
      containers: [],
      countries: [],
      users: [],
      rrUsers: [],
      customers: [],
      customerMap: {},
      form: this.getClearFormObject(),
      streams: [],
      url: "",
      dateoptions: { year: "numeric", month: "short", day: "numeric" },
      selectDisable: true,
      responsibleSelectDisable: true,
      pos_document: [],
      data_document: [],
      customersLocalEntity: [],
      isHistoryModalActive: false,
      historyData: [],
      switchCustomerViewEnabled: null,
      status: [
        "New",
        "Raw data requested",
        "Raw data received",
        "Correction of data needed",
        "In query/awaiting info",
        "Work in progress",
        "Awaiting approval",
        "Ready to submit",
        "Report not required",
        "Submitted",
        "Submitted by customer",
        "No TD from customer",
        "Submitted Zero Submission"
      ],
      resubmitted: [
        "",
        "Customer Incorrect",
        "Reporting Responsible Incorrect"
      ],
      landbellEntities: [
        "",
        "H2C",
        "SAS",
        "LB",
        "UK",
        "Topengi",
        "Amazon Marketplace",
        "General Marketplace",
        "ERP UK"
      ],
      hasAccessToTracker: false
    };
  },
  watch: {
    users(newValue) {
      this.assignUsersInDropdown(newValue);
    }
  },
  mounted() {
    //only allow Admin and CAM to edit the reporting tracker info
    // Below code block is used to restrict user if that user tries to change URL directory to edit any other customer
    const switchCustomerData = this.fetchSwitchCustomerCache();
    if (switchCustomerData != null) {
      this.switchCustomerViewEnabled =
        switchCustomerData["isSwitchCustomerView"];
    }
    this.fetchCustomerProfileData();
    if (
      this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL) ||
      this.userHasPermission(Permission.RTRACKER_REPORT_CHANGE_OWN) ||
      this.isAction == "View"
    ) {
      this.hasAccessToTracker = true;
    }
    // else {
    //   this.$router.push({ name: "home" });
    // }

    this.checkSize();
    this.fetchCountries();
    this.fetchSchemes();
    this.fetchContainers();
    //this.getData();
    this.getReportById();
    this.fetchUserData();
    this.fetchCustomersProfileData();
    this.fetchAllReportsData();
    this.disableSelectProperty();
  },
  computed: {
    ...mapGetters([
      "userId",
      "userName",
      "userHasPermission",
      "userGroups",
      "isUserExternal"
    ]),
    disable() {
      if (this.isAction == "Edit" || this.isAction == "View") {
        return true;
      }
      return false;
    },
    isExternalUser() {
      // Don't show reporting responsible and comments section if user is external
      if (
        this.userGroups.includes(UserGroup.EXTERNAL_USER) &&
        this.isUserExternal
      ) {
        return true;
      }
      return false;
    },
    disableView() {
      if (this.isAction == "View") {
        return true;
      }
      return false;
    },
    disableReportingResponsible() {
      if (this.isAction == "View") {
        return true;
      } else if (this.isAction == "Edit") {
        if (this.reportingResponsibleDisable == false) {
          return false;
        }
        if (
          this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL) ||
          (this.userHasPermission(Permission.RTRACKER_REPORT_CHANGE_OWN) &&
            this.form.customer_account_manager_id == this.userId)
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    disableSeondReportingResponsible() {
      if (this.isAction == "View") {
        return true;
      } else if (this.isAction == "Edit") {
        if (this.form.reporting_responsible == this.userId) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    }
  },

  methods: {
    openReportRun() {
      this.$router.push({
        name: "reportManager.reportsList",
        query: { r_id: this.form.r_id }
      });
    },
    openReportHistory() {
      this.reportingTrackerService
        .getReportingTrackerHistory(this.form.id)
        .subscribe(
          response => {
            // Filter out entries where old_value equals new_value
            this.historyData = response.filter(item => {
              // Special case for null values - consider null and "" as equal
              if (
                (item.old_value === null && item.new_value === "") ||
                (item.old_value === "" && item.new_value === null)
              ) {
                return false;
              }

              // Regular equality check
              return item.old_value !== item.new_value;
            });

            this.isHistoryModalActive = true;
          },
          e => {
            this.$buefy.dialog.alert({
              title: "Error !",
              message: e.error,
              type: "is-danger",
              hasIcon: true,
              icon: "times-circle",
              iconPack: "fa",
              ariaRole: "alertdialog",
              ariaModal: true
            });
            console.log(e);
          }
        );
    },
    deleteFromFile(index) {
      this.file.length > 0 && this.file.splice(index, 1);
    },
    deleteFromdataUpload(index) {
      this.dataUpload.length > 0 && this.dataUpload.splice(index, 1);
    },
    deleteFromPosDocument(index) {
      this.form.pos_document.length > 0 &&
        this.form.pos_document.splice(index, 1);
    },
    deleteFromdataDocument(index) {
      this.form.data_document.length > 0 &&
        this.form.data_document.splice(index, 1);
    },
    checkSize() {
      screenPixelSize = screen.width;
      pixelRatio =
        window.devicePixelRatio ||
        window.screen.availWidth / document.documentElement.clientWidth;
      pixelRatio = pixelRatio.toFixed(1);

      if (
        (screenPixelSize > 1024 &&
          screenPixelSize < 1281 &&
          pixelRatio == 1.5) ||
        (screenPixelSize > 1580 && screenPixelSize < 1921 && pixelRatio == 1.5)
      ) {
        //this.loadZoomAdjustment();
      }
    },
    redirectToKDB() {
      window.open(this.url, "_blank");
    },
    redirectToCustomerProfile() {
      const customerId = this.form.parent_customer_id
        ? this.form.parent_customer_id
        : this.form.customer_id;
      this.$router.push({
        path: "/customers/view/" + customerId
      });
    },
    downloadProof(data) {
      const fileName = data.proof_of_submission;
      try {
        this.reportingTrackerService.exportProofOfSubmission(
          this.form.id,
          fileName
        );
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Download Error !",
          message: e.message,
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    downloadDataUpload(data) {
      const fileName = encodeURIComponent(data.document);
      try {
        this.customerUploadService.exportCustomerUpload(
          this.form.customer_upload_id,
          fileName,
          this.form.customer_id
        );
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Download Error !",
          message: e.message,
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    disableSelectProperty() {
      if (this.isAction == "Edit") {
        this.selectDisable = false;
        // Below conditions are to use to disable reporting responsible select property based on user role
        if (
          this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL) ||
          (this.userHasPermission(Permission.RTRACKER_REPORT_CHANGE_OWN) &&
            this.form.customer_account_manager_id == this.userId)
        ) {
          this.responsibleSelectDisable = true;
        } else {
          this.responsibleSelectDisable = false;
        }
      } else if (this.isAction == "View") {
        this.selectDisable = false;
        this.responsibleSelectDisable = false;
      }
    },
    fetchAllReportsData() {
      if (this.isAction == "Add") {
        this.reportingTrackerService.getOneOffReportsOnly().subscribe(
          response => {
            this.reports = response;
          },
          e => {
            console.log(e);
          }
        );
      } else {
        this.reportingTrackerService.getAllReports().subscribe(
          response => {
            this.reports = response;
          },
          e => {
            console.log(e);
          }
        );
      }
    },
    filterScheme(countryId) {
      this.schemeDataService.getByCountry(countryId).subscribe(
        response => {
          this.schemes = response;
        },
        e => {
          console.log(e);
        }
      );
    },
    filterStream(schemeId) {
      this.schemeDataService.get(schemeId).subscribe(
        response => {
          this.containers = response["container"];
          this.containers = this.containers.filter(e => e.name !== "General");
        },
        e => {
          console.log(e);
        }
      );
    },
    filterReports(streamId) {
      this.reportingTrackerService
        .getOneOffReportsOnly(this.form.scheme_id, streamId)
        .subscribe(
          response => {
            this.reports = response;
          },
          e => {
            console.log(e);
          }
        );
    },
    dateFormatter(dt) {
      if (dt != null) {
        return dt.toLocaleDateString("fr-CA");
      }
      return dt;
    },
    dateParser(dt) {
      return new Date(Date.parse(dt));
    },

    getClearFormObject() {
      return {
        id: null,
        customer_name: null,
        country: null,
        stream: null,
        report_type: null,
        reporting_frequency: null,
        period: null,
        planned_scheme_deadline: null,
        customer_account_manager: null,
        reporting_responsible: null,
        status: null,
        resubmitted: null,
        date_of_resubmission: null,
        landbellEntities: null,
        landbell_entity: null,
        revised_scheme_deadline: null,
        final_dataset_delivery_date: null,
        actual_submission_date: null,
        proof_of_submission: null,
        data_uplod: null,
        comments: null,
        customer_local_entity: null
      };
    },
    convertToDate(dt) {
      let newDate = null;
      if (dt != null) {
        newDate = new Date(dt);
      }
      return newDate;
    },
    getData() {
      if (this.$route.params.id) {
        if (this.$route.params.row) {
          this.form = this.$route.params.row;
          this.form.planned_scheme_deadline = this.convertToDate(
            this.form.planned_scheme_deadline
          );
          this.form.revised_scheme_deadline = this.convertToDate(
            this.form.revised_scheme_deadline
          );
          this.form.actual_submission_date = this.convertToDate(
            this.form.actual_submission_date
          );
          this.form.date_of_resubmission = this.convertToDate(
            this.form.date_of_resubmission
          );
          this.form.final_dataset_delivery_date = this.convertToDate(
            this.form.final_dataset_delivery_date
          );
        } else {
          // @ to do
          // these messages can be placed in common method
          // still need to implement record not found with user friendly way
          this.$buefy.toast.open({
            message: `Error: ${"Record does not exist."}`,
            type: "is-danger",
            queue: false
          });
        }
      }
    },
    getReportById() {
      if (this.isAction !== "Add" && this.isAction !== null) {
        this.reportingTrackerService
          .getReportById(this.$route.params.id, this.switchCustomerViewEnabled)
          .subscribe(
            response => {
              if (response.reporting_responsible == this.userId) {
                this.reportingResponsibleDisable = false;
              }
              this.form = response;
              //only allow Admin and CAM,RR,BackupCAM to edit the reporting tracker info.
              // Below code block is used to restrict user if that user tries
              // to change URL directory to edit any other customer information
              if (
                this.isAction == "View" ||
                this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL) ||
                (this.isAction == null &&
                  this.userHasPermission(
                    Permission.RTRACKER_REPORT_CHANGE_OWN
                  )) ||
                (this.userHasPermission(
                  Permission.RTRACKER_REPORT_CHANGE_OWN
                ) &&
                  this.form.customer_account_manager_id == this.userId) ||
                (this.userHasPermission(
                  Permission.RTRACKER_REPORT_CHANGE_OWN
                ) &&
                  this.form.backup_account_manager_id == this.userId) ||
                (this.userHasPermission(
                  Permission.RTRACKER_REPORT_CHANGE_OWN
                ) &&
                  this.form.reporting_responsible == this.userId)
              ) {
                this.hasAccessToTracker = true;
              } else {
                this.hasAccessToTracker = false;
              }
              // if (!this.hasAccessToTracker) this.$router.push({ name: "home" });
              this.file_name = decodeURIComponent(response.proof_of_submission);
              this.form.report_id = response.report_id;
              this.form.country_id = response.country;
              this.form.scheme_id = response.scheme;
              this.form.stream_id = response.stream;
              this.url = response.url;
              this.form.planned_scheme_deadline = this.convertToDate(
                response.planned_scheme_deadline
              );
              this.form.revised_scheme_deadline = this.convertToDate(
                response.revised_scheme_deadline
              );
              this.form.actual_submission_date = this.convertToDate(
                response.actual_submission_date
              );
              this.form.date_of_resubmission = this.convertToDate(
                response.date_of_resubmission
              );
              this.form.final_dataset_delivery_date = this.convertToDate(
                response.final_dataset_delivery_date
              );
              this.pos_document = response.pos_document;
              this.data_document = response.data_document
                ? response.data_document
                : [];
              this.$emit("updateReportFrequency", response.frequency);
            },
            e => {
              console.log(e);
            }
          );
      }
    },
    submit() {
      if (this.isAction == "Edit") {
        this.updateReport();
      } else {
        this.createReport();
      }

      this.$emit("confirm");
    },
    routeToReportingTracker() {
      this.$router.push({
        name: "reportingtracker",
        query: { id: this.$route.params.id }
      });
    },
    createReport() {
      this.form.customer_local_entity
        ? (this.form.customer_id = this.form.customer_local_entity)
        : "";
      this.reportingTrackerService
        .create(this.form, this.file, this.dataUpload)
        .subscribe(response => {
          this.$buefy.dialog.alert({
            title: "Success",
            message: "Report Created!",
            onConfirm: this.routeToReportingTracker()
          });
        }, this.handleApiError);
    },
    updateReport() {
      // Create a copy of the form to ensure we include all fields, even if they're empty strings
      const formData = { ...this.form };

      // Explicitly ensure resubmitted is included, even if it's an empty string
      formData.resubmitted = this.form.resubmitted || "";

      this.reportingTrackerService
        .update(formData, this.file, this.dataUpload)
        .subscribe(response => {
          this.$buefy.dialog.alert({
            title: "Success",
            message: "Report Updated!",
            onConfirm: this.routeToReportingTracker()
          });
        }, this.handleApiError);
    },
    handleApiError(reason) {
      let errorMessage = reason.response.data["detail"];

      if (
        reason.response.status == 403 &&
        reason.response.data.code == "token_not_valid"
      ) {
        alert("Session expired, please login again");
        this.authService.logout(this.$keycloak);
        return;
      }

      if (errorMessage == null || errorMessage == undefined) {
        errorMessage = "Invalid input";
      }
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
    },
    filterUsers(users, role) {
      const newUsers = [];
      for (const user of users) {
        const epradmin = user.groups.filter(e => e.name === role);
        if (epradmin.length > 0) {
          newUsers.push(user);
        }
      }
      return newUsers;
    },
    assignUsersInDropdown() {
      this.rrUsers = this.filterUsers(this.users, "Reporting Responsible");
    },
    prepareCustomerAccountManagerMap(data) {
      const resultDict = {};
      for (const idx in data) {
        const dataDict = data[idx];
        resultDict[dataDict["id"]] = dataDict["account_manager"];
      }

      return resultDict;
    },
    setAccountManager(customerId) {
      const account_manager_id = this.customerMap[customerId];
      if (account_manager_id != null) {
        this.form.customer_account_manager_id = account_manager_id;
      } else {
        this.form.customer_account_manager_id = null;
      }
      const custObj = this.customers.filter(function(obj) {
        return obj.id == customerId;
      });

      this.prepareCustomerLocalEntityData(customerId);
      this.form.landbell_entity = custObj[0].landbell_entity;
    },
    fetchCustomersProfileData() {
      this.customerMap = this.prepareCustomerAccountManagerMap(this.customers);
    },
    prepareCustomerLocalEntityData(customerId) {
      this.customerDataService.getCustomerLocalEntityData(customerId).subscribe(
        response => {
          this.customersLocalEntity = response;
        },
        e => {
          console.log(e);
        }
      );
    },
    uploadData(data) {
      this.dataUpload = data;
      this.$buefy.dialog.confirm({
        title: "Confirmation of Data Upload",
        message: "Do you really want to upload data for this report?",
        type: "is-primary",
        onCancel: () => this.handleUpdateReport("cancel"),
        onConfirm: () => this.handleUpdateReport("confirm")
      });
    },
    handleUpdateReport(action = "cancel") {
      if (action == "cancel") {
        this.dataUpload = [];
      } else if (action == "confirm") {
        this.$buefy.toast.open({
          message: "Data added for this report",
          type: "is-success",
          queue: false
        });
      }
    },

    confirm() {
      console.log("in");
    }
  }
};
</script>
<style scoped>
/* CARLOS DEFAULT
.upload-button-view {
  margin: 5px 1px 0px 0px;
}
*/
</style>
